import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Button, Form, Spin, Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { openNotification } from "../../../shared/notification";
import { get, post, put, uploadFile } from "../../../services";
import { useParams } from "react-router-dom";
// Components
import Basic from "../form/basic";
import Video from "../form/video";
import Features from "../form/features";
import Reviewer from "../form/reviewer";
import Gallery from "../form/gallery";
import Modal from "../form/upload-status-modal";
import { generateSlug, parseSlug } from "../../../utils/generate-slug";

const AddBlogs = () => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(1);
  const [loader, setLoader] = useState(false);
  const [information, setInformation] = useState({});
  const [getLoader, setGetLoader] = useState(true);
  const [propertyStatusMessage, setPropertyStatusMessage] = useState("");
  const [errors, setErrors] = useState();
  const [slug, setSlug] = useState("");
  const [timestamp, setTimestamp] = useState("");
  // All Uploaded Files
  const [fileList, setFileList] = useState([]);
  // Selected Agents - if option is selected to show box
  const [selectedAgents, setSelectedAgents] = useState("");
  // add selected Address
  const [selectedAdddress, setSelectedAdddress] = useState({
    lat: "",
    long: "",
    address: "",
  });

  // upload modal status
  const [uploadStatus, setUploadStatus] = useState("");
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const showStatusModal = () => {
    setIsStatusModalOpen(!isStatusModalOpen);
  };

  // GET SINGLE
  useEffect(() => {
    get(`/property/${id}`)
      .then((response) => {
        console.log("response?.data?.property?.slug", response?.data?.property);
        // Split slug and extract timestamp
        if (response?.data?.property?.slug) {
          const { baseSlug, timestamp } = parseSlug(
            response?.data?.property?.slug
          );
          setSlug(baseSlug);
          setTimestamp(timestamp);
        }
        // if slug is null then to create and to set it.
        else {
          const result = generateSlug(response?.data?.property?.title);
          setSlug(result);
          setTimestamp("");
        }
        console.log("response?.data?.property", response?.data?.property);
        console.log("latitude", parseFloat(response?.data?.property?.latitude));
        console.log(
          "longitude",
          parseFloat(response?.data?.property?.longitude)
        );
        //
        const images = [];
        response?.data?.property?.images?.map((item) => {
          return images.push({
            uid: item?.url,
            name: "image.png",
            status: "done",
            url: item?.url,
            image_type: "DB",
            alt_title: item.altTitle || "",
            meta_title: item?.metaData?.title || "",
            meta_description: item?.metaData?.description || "",
            meta_keywords: item?.metaData?.keywords || "",
          });
        });
        setFileList(images);
        setPropertyStatusMessage(response?.data?.property?.status);
        setSelectedAgents(response?.data?.property?.agentInformationDisplay);
        setInformation(response?.data?.property);
        setSelectedAdddress({
          lat: parseFloat(response?.data?.property?.latitude),
          long: parseFloat(response?.data?.property?.longitude),
          address: response?.data?.property?.address,
        });
        setGetLoader(false);
      })
      .catch((error) => {
        setLoader(false);
      });
  }, []);

  // navigation
  const navigation = [
    {
      key: "1",
      label: "Basic",
      children: (
        <Basic
          selectedAdddress={selectedAdddress}
          setSelectedAdddress={setSelectedAdddress}
          propertyStatusMessage={propertyStatusMessage}
          setPropertyStatusMessage={setPropertyStatusMessage}
          slug={slug}
          setSlug={setSlug}
          timestamp={timestamp}
        />
      ),
    },
    {
      key: "2",
      label: "Gallery",
      children: (
        <Gallery
          fileList={fileList}
          setFileList={setFileList}
          information={information}
        />
      ),
    },
    {
      key: "3",
      label: "Video",
      children: <Video />,
    },
    {
      key: "4",
      label: "Features",
      children: <Features />,
    },
    {
      key: "5",
      label: "Agent & Reviewer",
      children: (
        <Reviewer
          selectedAgents={selectedAgents}
          setSelectedAgents={setSelectedAgents}
        />
      ),
    },
  ];

  // for floorplan
  const uploadFiles = async (file) => {
    try {
      const response = await uploadFile("/getSignUrlForUpload", {
        file: file?.file,
      });
      return { ...file, img: response?.data?.publicUrl, index: file.index };
    } catch (error) {
      openNotification("Error", "File upload failed.");
      return false;
    }
  };

  // for images
  const uploadImagesFiles = async (file) => {
    try {
      const response = await uploadFile("/getSignUrlForUpload", {
        file: file,
      });
      return response?.data?.publicUrl;
    } catch (error) {
      openNotification("Error", "File upload failed.");
      return false;
    }
  };

  // uploadAllFiles handler to upload array - (Floor Plan)
  const uploadAllFiles = async (files) => {
    try {
      // Map over the files and upload each one using promises
      const uploadPromises = files.map((file) => {
        // Check for spaces in the file name
        const now = new Date();
        const formattedTime = now.toISOString().replace(/[-:TZ.]/g, ""); // Remove special characters
        const milliseconds = now.getMilliseconds().toString().padStart(3, "0");
        const extension = file?.file.name.split(".").pop();
        const newName = `${formattedTime}${milliseconds}.${extension}`;
        // Create a new File object with the same contents and modified name
        const renamedFile = {
          ...file,
          file: new File([file?.file], newName, {
            type: file.type,
            lastModified: file.lastModified,
          }),
          index: file?.index,
        };
        return uploadFiles(renamedFile);
      });

      // Wait for all the upload promises to complete
      const uploadResults = await Promise.all(uploadPromises);

      return uploadResults;
    } catch (error) {
      openNotification("Error", "One or more file uploads failed.");
      return [];
    }
  };

  // uploadAllNewImages - Images
  const uploadAllNewImages = async (files) => {
    try {
      // Map over the files and upload each one using promises
      const uploadPromises = files.map(async (item) => {
        const file = item.originFileObj;
        // To Chnage file name
        const now = new Date();
        const formattedTime = now.toISOString().replace(/[-:TZ.]/g, ""); // Remove special characters
        const milliseconds = now.getMilliseconds().toString().padStart(3, "0");
        const extension = file.name.split(".").pop();
        const baseName = file.name
          .substring(0, file.name.lastIndexOf("."))
          .replace(/[^a-zA-Z0-9]/g, ""); // remove non-alphanumeric
        const newName = `${baseName}_${formattedTime}${milliseconds}.${extension}`;
        // Create a new File object with the same contents and modified name
        const renamedFile = new File([file], newName, {
          type: file.type,
          lastModified: file.lastModified,
        });
        // Upload the renamed file
        const uploadedUrl = await uploadImagesFiles(renamedFile);

        // return uploadFiles(renamedFile);
        return {
          url: uploadedUrl,
          alt_title: item.alt_title || "",
          meta_title: item.meta_title || "",
          meta_description: item.meta_description || "",
          index: item?.index,
        };
      });

      // Wait for all the upload promises to complete
      const uploadResults = await Promise.all(uploadPromises);
      return uploadResults;
    } catch (error) {
      openNotification("Error", "One or more file uploads failed.");
      return [];
    }
  };

  // floorPlanImageHandler
  const floorPlanImageHandler = async (floorPlan) => {
    let floorList = [];
    let floorImages = [];
    let finalFloorImages = [];
    floorPlan?.map((item, index) => {
      if (item?.floorImage) {
        floorList.push({ floorName: item?.floorName, floorPlanImage: "" });
        floorImages.push({ file: item?.floorImage?.file, index: index });
      } else {
        floorList.push(item);
      }
    });
    if (floorImages?.length > 0) {
      setUploadStatus("Floor");
      openNotification("Uploading", "Please Wait To Upload All Floor Images");
      const uploadedFiles = await uploadAllFiles(floorImages);
      floorList.forEach((item, index) => {
        if (item?.floorPlanImage === "") {
          // Find matching uploaded image by index
          const uploadedImageObj = uploadedFiles.find(
            (imgObj) => parseInt(imgObj?.index) === index
          );
          finalFloorImages.push({
            ...item,
            floorPlanImage: uploadedImageObj?.img || "", // fallback to empty if not found
          });
        } else {
          finalFloorImages.push(item); // Keep original if not empty
        }
      });
      return finalFloorImages;
    } else {
      return floorList;
    }
  };

  // Submit Handler
  const onFinish = async (values) => {
    // Tab 1 Conditions
    if (
      (activeTab === 5 && !selectedAdddress?.lat && !selectedAdddress?.long) ||
      (activeTab === 1 && !selectedAdddress?.lat && !selectedAdddress?.long)
    ) {
      openNotification("Error", "Please Select Address in Map");
    }
    // Tab 2 ,3, 4 Conditions
    else if (
      activeTab === 1 ||
      activeTab === 2 ||
      activeTab === 3 ||
      activeTab === 4
    ) {
      setActiveTab(activeTab + 1);
    }
    // Tab 5 Conditions.
    else if (activeTab === 5 && values?.acceptTermsAndConditions === false) {
      openNotification("Error", "Please Accept Terms & Conditions");
    } else if (activeTab === 5) {
      setLoader(true);

      // to upload videos
      const videos = values?.videos?.some(
        (item) => Object.keys(item).length === 0 && item.constructor === Object
      )
        ? null
        : values?.videos;

      // to get all new listings
      let newAddedFiles = [];
      let savedFiles = [];

      // to filter out new added files and saved files
      [...fileList]?.map((img, index) => {
        if (img?.image_type !== "DB") {
          return newAddedFiles?.push({
            ...img,
            index: index,
          });
        } else if (img?.image_type === "DB") {
          savedFiles?.push({ img: img?.url, index: index, ...img });
        }
      });
      // to check new added files
      if (newAddedFiles?.length > 0) {
        openNotification("Uploading", "Please Wait To Upload All New Images");
        setUploadStatus("Gallery");
      }
      // to open a modal
      showStatusModal();
      let floorPlanArray = null;

      // to check floor plan
      const shouldShowFloor =
        Array.isArray(values?.floorPlans) &&
        values?.floorPlans !== undefined &&
        values?.floorPlans?.length > 0 &&
        !(
          (values?.floorPlans?.length === 1 &&
            Object.keys(values?.floorPlans[0]).length === 0) ||
          (values.floorPlans[0].floorName === undefined &&
            values.floorPlans[0].floorImage === undefined)
        );
      // to upload images
      const filesUrl =
        newAddedFiles?.length > 0
          ? await uploadAllNewImages(newAddedFiles)
          : [];
      // to upload floor images
      if (
        values?.floorPlans &&
        values?.floorPlans?.length > 0 &&
        shouldShowFloor
      ) {
        floorPlanArray = await floorPlanImageHandler(values?.floorPlans);
      }

      // to combine all files on basis of drag and drop
      const sortedFiles = [...filesUrl, ...savedFiles]
        ?.sort((a, b) => a.index - b.index)
        .map((item) => ({
          url: item?.url || "",
          altTitle: item.alt_title || "",
          metaData: {
            title: item.meta_title || "",
            description: item.meta_description || "",
            keywords: item.meta_keywords || "",
          },
        }));
      // to check image uploaded
      let img = true;
      await fileList?.map((img) => {
        if (img === false) {
          img = false;
        }
      });
      if (img !== false) {
        setUploadStatus("Final");
        let payload = {
          ...values,
          slug: slug,
          // slug: timestamp ? `${slug}-${timestamp}` : slug,
          images: sortedFiles,
          latitude: selectedAdddress?.lat,
          longitude: selectedAdddress?.long,
          address: selectedAdddress?.address,
          videos: videos,
        };
        if (floorPlanArray !== "null" || floorPlanArray !== null) {
          payload = { ...payload, floorPlans: floorPlanArray };
        }
        put(`/property/${id}`, payload)
          .then(() => {
            form.resetFields();
            openNotification("Success", "Property updated successfully");
            setLoader(false);
            setIsStatusModalOpen(false);
            navigate("/");
          })
          .catch((error) => {
            setLoader(false);
            setIsStatusModalOpen(false);
            setErrors(error?.response?.data?.message);
            openNotification("Error", error?.response?.data?.message);
          });
      } else {
        openNotification("Error", "Failed To Upload New Files");
        setLoader(false);
        setIsStatusModalOpen(false);
      }
    }
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>Add Property</title>
        <meta name="description" content="Add and manage properties" />
      </Helmet>
      {/* Modal */}
      <Modal
        isStatusModalOpen={isStatusModalOpen}
        setIsStatusModalOpen={setIsStatusModalOpen}
        showStatusModal={showStatusModal}
        uploadStatus={uploadStatus}
      />
      {/* Header */}
      <div className="header">
        <h3>{id ? "Edit" : "Add"} Property</h3>
      </div>
      {getLoader ? (
        <div className="spin_information">
          <Spin />
        </div>
      ) : (
        <div className="form_container">
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={{
              // Basic
              title: information?.title,
              slug: information?.slug,
              saleOrRentprice: information?.saleOrRentprice,
              pricePrefix: information?.pricePrefix,
              pricePostfix: information?.pricePostfix,
              type: information?.type,
              status: information?.status,
              location: information?.location,
              bedrooms: information?.bedrooms,
              bathrooms: information?.bathrooms,
              garagesOrParkingSpaces: information?.garagesOrParkingSpaces,
              area: information?.area,
              areaPostfix: information?.areaPostfix,
              developer: information?.developer,
              handoverDate: information?.handoverDate,
              propertyStatusMessage: information?.propertyStatusMessage,
              description: information?.description,
              isPropertyUnPublished: information?.isPropertyUnPublished,
              isFeatured: information?.isFeatured,
              soldOut: information?.soldOut,
              address: information?.address,
              markerPosition: information?.markerPosition,
              finishing_type: information?.finishing_type,
              offering_type: information?.offering_type,
              uae_emirate: information?.uae_emirate,
              referenceNumber: information?.referenceNumber,
              // Gallery
              floorPlans: information?.floorPlans,
              meta_title:
                information?.meta_title && information?.meta_title?.length > 0
                  ? information?.meta_title[0]
                  : "",
              meta_keyword:
                information?.meta_keyword &&
                information?.meta_keyword?.length > 0
                  ? information?.meta_keyword[0]
                  : "",
              meta_description:
                information?.meta_description &&
                information?.meta_description?.length > 0
                  ? information?.meta_description[0]
                  : "",
              // Features
              additionalDetails: information?.additionalDetails,
              features: information?.features,
              propertyLabel: information?.propertyLabel,
              // videos
              videos: information?.videos,
              // agent details
              agentInformationDisplay: information?.agentInformationDisplay,
              acceptTermsAndConditions: information?.acceptTermsAndConditions,
              selectedAgents: information?.selectedAgents,
              listing_agent: information?.listing_agent,
              listing_owner: information?.listing_owner,
            }}
          >
            {/* Tabs */}
            <Tabs
              defaultActiveKey={activeTab}
              activeKey={activeTab?.toString()}
              items={navigation}
              onChange={(e) => {
                setActiveTab(parseInt(e));
              }}
            />
            {/* Errors */}
            {errors && (
              <div style={{ color: "red", fontSize: 14 }}>{errors}</div>
            )}
            {/* Footer Buttons */}
            <Form.Item>
              <div className="form_submit pt-15">
                <Button
                  className="back_button"
                  onClick={() => {
                    setActiveTab(activeTab === 1 ? 1 : activeTab - 1);
                  }}
                  disabled={activeTab === 1}
                >
                  Back
                </Button>

                <Button htmlType="submit" type="primary">
                  {activeTab < 5 ? "Next" : loader ? "Please Wait..." : "Save"}
                </Button>
              </div>
            </Form.Item>
          </Form>
        </div>
      )}
    </React.Fragment>
  );
};

export default AddBlogs;
